import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import Layout from './components/layout/Layout'
import Dashboard from './pages/Dashboard/Dashboard'
import Overview from './pages/Overview/Overview'
import { Predictions, EnergyForecast, WeatherModel, Performance, AnomalyDetection, NeuralNetworks, TimeSeries, Classification, DataPipeline, LiveAnalytics, AnalyticsReports } from './pages/AI'
import AnomalyNotification from './components/AI/AnomalyNotification'
import TechnicalDashboard from './pages/TechnicalDashboard'
import { BlockDetails } from './pages/BlockDetails'
import { InverterMetrics } from './pages/InverterMetrics'
import { YieldComparison } from './pages/YieldComparison'

import Live247 from './pages/Live/Live247'
import Monitoring from './pages/Monitoring'
import Equipment from './pages/System/Equipment'
import EquipmentMonitoring from './pages/Equipment/EquipmentMonitoring'
import PlantDashboard from './pages/PlantDashboard'
import PowerHeatmap from './pages/PowerHeatmap'
import InverterTrendAnalysis from './pages/InverterTrendAnalysis'
import { WeatherDiagnostics } from './pages/WeatherDiagnostics'
import BlockGenerationDashboard from './pages/BlockGenerationDashboard'
import { DailyReports } from './pages/DailyReports'
import { CUFGenerationDashboard } from './pages/CUFGenerationDashboard'
import { MeterExportImport } from './pages/MeterExportImport'
import InverterDashboard from './pages/InverterDashboard'
import SupervisoryDashboard from './pages/SupervisoryDashboard'
import FaultIntelligencePage from './pages/FaultIntelligencePage'

import Settings from './pages/System/Settings'
import AIOperator from './pages/System/AIOperator'
import Admin from './pages/System/Admin'
import Login from './pages/Auth/Login'
import ProtectedRoute from './components/ProtectedRoute'
import './styles/globals.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
})

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/overview" element={<Overview />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/technical-dashboard" element={<TechnicalDashboard />} />
                  <Route path="/block-details" element={<BlockDetails />} />
                  <Route path="/inverter-metrics" element={<InverterMetrics />} />
                  <Route path="/power-heatmap" element={<PowerHeatmap />} />
                  <Route path="/inverter-trend-analysis" element={<InverterTrendAnalysis />} />
                  <Route path="/yield-comparison" element={<YieldComparison />} />
                  <Route path="/block-generation" element={<BlockGenerationDashboard />} />
                  <Route path="/cuf-generation" element={<CUFGenerationDashboard />} />
                  <Route path="/weather-diagnostics" element={<WeatherDiagnostics />} />
                  <Route path="/meter-export-import" element={<MeterExportImport />} />
                  <Route path="/inverter-dashboard" element={<InverterDashboard />} />
                  <Route path="/supervisory-dashboard" element={<SupervisoryDashboard />} />
                  <Route path="/fault-intelligence" element={<FaultIntelligencePage />} />
                  <Route path="/reports/daily" element={<DailyReports />} />
                  <Route path="/live/monitoring" element={<Monitoring />} />
                  <Route path="/live/24-7" element={<Live247 />} />
                  <Route path="/ai/predictions" element={<Predictions />} />
                  <Route path="/ai/energy-forecast" element={<EnergyForecast />} />
                  <Route path="/ai/weather-model" element={<WeatherModel />} />
                  <Route path="/ai/performance" element={<Performance />} />
                  <Route path="/ai/anomaly-detection" element={<AnomalyDetection />} />
                  <Route path="/ai/ml/neural-networks" element={<NeuralNetworks />} />
                  <Route path="/ai/ml/time-series" element={<TimeSeries />} />
                  <Route path="/ai/ml/classification" element={<Classification />} />
                  <Route path="/ai/analytics/data-pipeline" element={<DataPipeline />} />
                  <Route path="/ai/analytics/live" element={<LiveAnalytics />} />
                  <Route path="/ai/analytics/reports" element={<AnalyticsReports />} />
                  <Route path="/system/equipment" element={<Equipment />} />
                  <Route path="/equipment" element={<EquipmentMonitoring />} />
                  <Route path="/plant/:plantSlug" element={<PlantDashboard />} />
                  <Route path="/plant" element={<PlantDashboard />} />
                  <Route path="/system/settings" element={<Settings />} />
                  <Route path="/system/ao" element={<AIOperator />} />
                  <Route path="/system/admin" element={<Admin />} />
                  <Route path="/system/online" element={<Monitoring />} />
                  <Route path="/" element={<Live247 />} />

                </Routes>
              </Layout>
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
          }}
        />
        <AnomalyNotification />
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App